/**
 * @generated SignedSource<<7226a292d44a0cad2ea01fd041a158af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Step1SelectWorkflowListGithubWorkflowsQuery$variables = {
  integrationId: any;
  repoFullName: string;
};
export type Step1SelectWorkflowListGithubWorkflowsQuery$data = {
  readonly listGithubWorkflows: ReadonlyArray<any>;
};
export type Step1SelectWorkflowListGithubWorkflowsQuery = {
  response: Step1SelectWorkflowListGithubWorkflowsQuery$data;
  variables: Step1SelectWorkflowListGithubWorkflowsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "integrationId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "repoFullName"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "integrationId",
        "variableName": "integrationId"
      },
      {
        "kind": "Variable",
        "name": "repoFullName",
        "variableName": "repoFullName"
      }
    ],
    "kind": "ScalarField",
    "name": "listGithubWorkflows",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Step1SelectWorkflowListGithubWorkflowsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Step1SelectWorkflowListGithubWorkflowsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1a4b24041b0168bb3a9514aafe8c8ba9",
    "id": null,
    "metadata": {},
    "name": "Step1SelectWorkflowListGithubWorkflowsQuery",
    "operationKind": "query",
    "text": "query Step1SelectWorkflowListGithubWorkflowsQuery(\n  $integrationId: GlobalID!\n  $repoFullName: String!\n) {\n  listGithubWorkflows(integrationId: $integrationId, repoFullName: $repoFullName)\n}\n"
  }
};
})();

(node as any).hash = "7e3c23772c1c6b3d2364aac51b777875";

export default node;
